import React from 'react';
import header_vmw from './Recursos/header_kmi_vwm_movil_sep20.png';
import header_pantalla_generica from './Recursos/header_pantalla_generica_movil_kmi_sep20.png';
import header_pantalla_generica_1440 from './Recursos/header_1440_KMI_generica_web_sep20.png';
import header_pantalla_generica_1920 from './Recursos/header_1920_KMI_generica_web_sep20.png';
import logo_audi from './Recursos/logo_audi_kmi_m_sep20.png';
import logo_seat from './Recursos/logo_seat_kmi_m_sep20.png';
import logo_vw from './Recursos/logo_vw_kmi_m_sep20.png';
import logo_vwcomerciales from './Recursos/logo_vwcomerciales_kmi_m_sep20.png';
import './PantallaGenericaMovil.css';

class PantallaGenerica extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="header_kmi_vwm_movil_sep20__container">
                    <img src={header_vmw} alt="header_kmi_vwm_movil_sep20" />
                </div>
                <div className="header_pantalla_generica__container d-xs-block d-sm-none">
                    <img src={header_pantalla_generica} alt="header_pantalla_generica" />
                </div> 
                <div className="header_pantalla_generica__container d-none d-sm-block d-md-block d-lg-none">
                    <img src={header_pantalla_generica_1440} alt="header_pantalla_generica" />
                </div> 
                <div className="header_pantalla_generica__container d-none d-lg-block">
                    <img src={header_pantalla_generica_1920} alt="header_pantalla_generica" />
                </div> 
                <div className="container">
                    <div className="mt-4 mb-4 offset-md-2">
                        <h4>Bienvenido a <b>Keep Me Informed</b> Multimarca</h4>
                    </div>
                    <div className="mt-4 mb-4 offset-md-2">
                        <p>Selecciona la marca de tu interés para mantenerte 
                        informado en tu proceso de compra.</p>
                    </div>
                    <div className=" container_images row">
                        <div className="mt-2 mb-2 offset-lg-2 col-lg-2">
                            <a href={"/vw/inicio"}><img src={logo_vw} alt="logo_vw" /></a>
                        </div>
                        <div className="mt-2 mb-2 col-lg-2">
                            <a href={"/audi/inicio"}><img src={logo_audi} alt="logo_audi" /></a>
                        </div>
                        <div className="mt-2 mb-2 col-lg-2">
                            <a href={"/seat/inicio"}><img src={logo_seat} alt="logo_seat" /></a>
                        </div>
                        <div className="mt-2 mb-2 col-lg-2">
                            <a href={"/vw/inicio"}><img src={logo_vwcomerciales} alt="logo_vwcomerciales" /></a>
                        </div> 
                    </div>
                    <div className="">
                        <p className="mt-5 mb-5 offset-md-2"><small>&copy; Volkswagen de México 2020</small></p>
                    </div>
                </div> 
            </React.Fragment>
        );
    }
}

export default PantallaGenerica;